export enum EventUserRolesEnum {
    Owner = 'f1c14346-d79d-47cb-bd8b-d433377da857',
    CoOwner = 'd79df1c1-4346-47cb-a857-d433377dbd8b',
    Guest = 'f35476e6-294c-48a0-bf1d-8ee34aa37417',
}
